export default class QuestionSet {
  constructor(questions, setName) {
    this.questions = questions;
    this.setName = setName;
  }
}
